<template>
  <div id="mapView"></div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import gcoord from "gcoord";
import api from "@/api";
export default {
  props: {
    menuData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      centerPoint: "",
      active: null,
      map: {
        map: null,
        pointLayer: null, //环境监测图层
        PVLayer: null, //光伏图层
      },
      EMSList: [], //环境监测
      popupList: [],
      newArr: [],
    };
  },
  watch: {
    "menuData.EMSList": {
      handler: function (newVal, oldVal) {
        this.EMSList = newVal;
        this.handleData();
      },
    },
    "menuData.clickData": {
      handler: function (newVal, oldVal) {
        this.active = newVal.deviceId ?? null;
        this.changePop();
      },
    },
    "menuData.PVList": {
      handler(newVal, oldVal) {
        let arr = newVal.filter((v) => {
          return v.Longitude && v.Latitude;
        });
        this.clearMap();
        if (arr.length) {
          this.addPVPoint(arr);
        }
      },
    },
    "menuData.PVClick": {
      handler(newVal, oldV) {
        // console.log("watch1", newVal);
        this.handleActive();
      },
    },
  },
  methods: {
    async getMapPiont() {
      let res = await api.backstageGetList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        pageName: "mapCenterPoint",
      });
      if (res && res.status == 200) {
        if (res.data.length && res.data[0].additionalInfo) {
          let point = res.data[0].additionalInfo;
          this.centerPoint = [point.latitude, point.longitude];
        } else {
          this.centerPoint = [29.35642037, 106.60893828];
        }
        this.initMap();
      }
    },
    initMap() {
      let map = L.map("mapView", {
        minZoom: 4,
        center: this.centerPoint,
        zoom: 17,
        maxZoom: 18,
        maxNativeZoom: 18,
        zoomControl: false,
        attributionControl: false,
      });
      this.map.map = map;
      window.map = map;
      L.tileLayer(
        "http://t0.tianditu.gov.cn/vec_w/wmts?" +
          "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
          "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
          "&tk=7a313b93639a9e1fb4a3c41699c7d3cc",
        {
          attribution: "stamen",
        }
      ).addTo(map);
      L.tileLayer(
        "http://t0.tianditu.gov.cn/cva_w/wmts?" +
          "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles" +
          "&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}" +
          "&tk=7a313b93639a9e1fb4a3c41699c7d3cc",
        {
          attribution: "stamen",
        }
      ).addTo(map);
      // map.on("click", (e) => {
      //   console.log(e);
      // });
    },
    /*****   环境监测方法开始      * */
    // 添加环境监测点
    addPoint(data) {
      // console.log("data", data);
      let _this = this;
      this.popupList.forEach((v) => {
        v.remove();
      });
      this.popupList = [];
      // this.active = this.menuData.clickData.deviceId ?? null;
      this.map.pointLayer = L.layerGroup().addTo(this.map.map);
      data.map((item) => {
        let result = gcoord.transform(
          [item.longitude, item.latitude], // 经纬度坐标
          gcoord.GCJ02, // 当前坐标系
          gcoord.WGS84 // 目标坐标系
        );
        let starIcon = L.icon({
          iconUrl: require(`@/assets/images/xitong/${item.state}.png`),
          iconSize: [28, 40], // 图标尺寸
          // iconAnchor: [16, 20], // 图标偏移
        });
        let marker = L.marker([result[1], result[0]], {
          icon: starIcon,
        }).addTo(this.map.pointLayer);
        let str = ``;

        if (item.list.length) {
          item.list.forEach((v, i) => {
            let itemStr = JSON.stringify(JSON.parse(JSON.stringify(v)));
            str += `
          <div style='font-size:12px;font-weight:bold ; opacity: 0.8;display:flex;align-items: center;padding:5px 0 10px' onclick='toInfo(${itemStr},event)'>
          <img style='width:25px;height:30px;margin-right:5px;' src='${require(`@/assets/images/xitong/${v.state}.png`)}'>
          <span class="mapPopupRow ${
            v.deviceId == _this.active ? "activeRow" : ""
          }" style='disply:inline-block;cursor: default;'>${v.name}</span>
          </div>
          `;
          });
          marker.bindPopup(str, { maxHeight: 350, maxWidth: 300 });
          this.popupList.push(marker);
        }
      });
    },
    // 左侧列表点击变更选中弹窗
    changePop() {
      this.clearMap();
      this.addPoint(this.newArr);
      this.popupList.map((v) => {
        let result = gcoord.transform(
          [this.menuData.clickData.longitude, this.menuData.clickData.latitude],
          gcoord.GCJ02,
          gcoord.WGS84
        );
        if (result[1] == v._latlng.lat && result[0] == v._latlng.lng) {
          v.openPopup();
        }
      });
    },
    /*****   环境监测方法结束      * */
    // 处理数据聚合
    handleData() {
      let data = this.EMSList;
      if (data.length == 0) {
        this.clearMap();
        return;
      }
      let arr = data.filter((v) => {
        return v.latitude && v.longitude;
      });
      //  传入一个数组按照特定方式格式化
      function sortArr(arr, str) {
        var _arr = [],
          _t = [],
          _tmp;
        // 按照特定的参数将数组排序将具有相同值得排在一起
        arr = arr.sort(function (a, b) {
          var s = a[str],
            t = b[str];
          return s < t ? -1 : 1;
        });

        if (arr.length) {
          _tmp = arr[0][str];
        }
        // 将相同类别的对象添加到统一个数组
        for (let i in arr) {
          if (arr[i][str] === _tmp) {
            _t.push(arr[i]);
          } else {
            _tmp = arr[i][str];
            _arr.push(_t);
            _t = [arr[i]];
          }
        }
        _arr.push(_t);
        return _arr;
      }
      let NewArr = sortArr(arr, "latitude");
      if (NewArr.length == 0) {
        this.clearMap();
        return;
      }
      NewArr = Array.from(NewArr).map((item, index) => ({
        deviceId: "",
        name: "",
        latitude: item[0].latitude,
        longitude: item[0].longitude,
        state:
          item.findIndex((v) => {
            return v.state == "alert";
          }) != -1
            ? "alert"
            : item.findIndex((v) => {
                return v.state == "offline";
              }) != -1
            ? "offline"
            : "online",
        status: "",
        list: item,
      }));
      this.newArr = NewArr;
      this.clearMap();
      this.addPoint(NewArr);
    },
    /*****   光伏系统方法开始      * */
    addPVPoint(data) {
      this.clearMap();
      let _this = this;
      this.popupList.forEach((v) => {
        v.remove();
      });
      this.popupList = [];
      this.map.PVLayer = L.layerGroup().addTo(this.map.map);
      data.map((item) => {
        if (item.type == "电站") {
          item.img = "station";
        } else if (item.type == "逆变器") {
          item.img = "inverter";
        } else if (item.type.indexOf("摄像") != -1) {
          item.img = "camera";
        }
        let imgTxt =
          item.status == "active"
            ? `active${item.img}`
            : item.status == "alarm"
            ? `alarm${item.img}`
            : item.img;
        let result = gcoord.transform(
          [item.Longitude, item.Latitude], // 经纬度坐标
          gcoord.GCJ02, // 当前坐标系
          gcoord.WGS84 // 目标坐标系
        );
        let starIcon = L.icon({
          iconUrl: require(`@/assets/images/xitong/guangfu/${imgTxt}.png`),
          iconSize: [35, 40], // 图标尺寸
          // iconAnchor: [16, 20], // 图标偏移
        });
        let marker = L.marker([result[1], result[0]], {
          id: item.id,
          icon: starIcon,
        }).addTo(this.map.PVLayer);
        let str = "";
        let itemStr = JSON.stringify(JSON.parse(JSON.stringify(item)));
        if (item.img === "camera") {
          str += `
           <div class='mapDisasterPopup'>
            <div style='margin:10px 10px'>
              <div class="title1 title">${item.name}</div>
              <div class="title1">关联电站：${item.relatedStation ?? ""}</div>
              <div class="title1">关联逆变器：${
                item.RelatedInverter ?? ""
              }</div>
              <div class="title1">设备类型：${item.type}</div>
              <div class="title1">设备编号：${item.Encode ?? ""}</div>
              <div class="title1">设备状态：${
                item.status == "active" ? "在线" : "离线"
              }</div>
              <div class="btn" style='display:${
                _this.$route.path == "/photovoltaicSystem" ? "block" : "none"
              }' onclick='toInfo(${itemStr},event)'>查看详情</div>
            </div>
          </div>
          `;
        } else if (item.img === "station") {
          str += `
          <div class='mapDisasterPopup'>
            <div style='margin:10px 10px'>
              <div class="title1 title">${item.name}</div>
              <div class="title1">逆变器数量：${item.inverterCount ?? ""}</div>
              <div class="title1">并网电压：${item.UA ?? ""}V</div>
              <div class="title1">装机功率：${item.InstalledPower}kwp</div>
              <div class="title1">实时发电功率：${item.Power ?? ""}kw</div>
              <div class="btn" onclick='toInfo(${itemStr},event)'>查看详情</div>
            </div>
          </div>
          `;
        } else if (item.img === "inverter") {
          str += `
          <div class='mapDisasterPopup'>
            <div style='margin:10px 10px'>
              <div class="title1 title">${item.name}</div>
              <div class="title1">今日发电量：${item.EacToday ?? ""}kw·h</div>
              <div class="title1">额定功率：${
                item.InstalledPower ?? ""
              }kwp</div>
              <div class="title1">峰值功率：${
                item.InstalledPower ?? ""
              }kwp</div>
              <div class="title1">实时发电功率：${item.Power ?? ""}kw</div>
              <div class="btn" onclick='toInfo(${itemStr},event)'>查看详情</div>
            </div>
          </div>
          `;
        }
        marker.bindPopup(str);
        this.popupList.push(marker);
        marker.on("click", () => {
          this.handlerMapClick(item);
        });
      });
    },
    // 目录选中更改地图弹窗
    handleActive() {
      if (this.menuData.PVClick.Longitude && this.menuData.PVClick.Latitude) {
        this.popupList.map((v) => {
          if (v.options.id == this.menuData.PVClick.id) {
            v.openPopup();
          }
          // let result = gcoord.transform(
          //   [this.menuData.PVClick.Longitude, this.menuData.PVClick.Latitude],
          //   gcoord.GCJ02,
          //   gcoord.WGS84
          // );
          // if (result[1] == v._latlng.lat && result[0] == v._latlng.lng) {
          //   v.openPopup();
          // }
        });
      } else {
        this.map.map.closePopup();
      }
    },

    /**    光伏方法结束** */

    // 处理地图上点击标记变更列表选中项
    handlerMapClick(data) {
      this.$bus.$emit("getMapClickFun", data);
    },

    // 地图上点击列表变更选中弹窗/光伏中点击查看详情
    toInfo(item, $event) {
      if (this.$route.path == "/indoorsDataDetails") {
        //环境监测
        this.$bus.$emit("getMapClickFun", item);
        let documentArr = document.getElementsByClassName("mapPopupRow");
        for (let i = 0; i < documentArr.length; i++) {
          documentArr[i].className = "mapPopupRow";
        }
        $event.target.className = "mapPopupRow activeRow";
      } else if (this.$route.path == "/photovoltaicMonitor") {
        //光伏--监控管理
      } else if (this.$route.path == "/photovoltaicSystem") {
        //光伏系统
        this.$router.push({
          name:
            item.img == "camera"
              ? "photovoltaicMonitor"
              : "photovoltaicStation",
          params: { id: item.id },
        });
      }
    },
    // 地图图层清理
    clearMap() {
      //环境监测
      if (this.map.pointLayer) {
        this.map.pointLayer.remove();
        this.map.pointLayer = null;
      }
      // 光伏系统
      if (this.map.PVLayer) {
        this.map.PVLayer.remove();
        this.map.PVLayer = null;
      }
    },
  },
  created() {
    if (!window.toInfo) {
      window.toInfo = this.toInfo;
    }
  },
  mounted() {
    this.getMapPiont();
  },
  beforeDestroy() {
    this.$bus.$off("getMapClickFun");
  },
  deactivated() {
    this.map.map.closePopup();
  },
};
</script>

<style lang="scss" scoped>
#mapView {
  width: 100%;
  height: 100%;
}
</style>
